import type { LucideIcon } from "lucide-react";

type Props = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export function EmptyState({ icon: Icon, title, description }: Props) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border-subtle bg-bg-secondary/50 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-bg-tertiary">
        <Icon className="h-7 w-7 text-text-muted" aria-hidden="true" />
      </div>
      <p className="font-display text-xl text-text-secondary">{title}</p>
      <p className="mt-2 max-w-xs text-sm text-text-muted">{description}</p>
    </div>
  );
}
